var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolNoHistoryList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0283 0C19.7121 0 0 19.7121 0 44.0283C0 53.099 2.74411 61.5282 7.44593 68.5334L14.2753 76.4798C22.1112 83.668 32.5568 88.0566 44.0283 88.0566C68.3445 88.0566 88.0566 68.3445 88.0566 44.0283C88.0566 19.7121 68.3445 0 44.0283 0Z",
    fill: "#2C2C7C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26747_24099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 89,
    height: 89
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0283 0C19.7121 0 0 19.7121 0 44.0283C0 53.099 2.74411 61.5282 7.44593 68.5334L14.2753 76.4798C22.1112 83.668 32.5568 88.0566 44.0283 88.0566C68.3445 88.0566 88.0566 68.3445 88.0566 44.0283C88.0566 19.7121 68.3445 0 44.0283 0Z",
    fill: "#2C2C7C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26747_24099)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26747_24099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96136 38.773L44.4038 13L76.7513 38.6316C77.4767 39.2064 77.8996 40.0812 77.8996 41.0067V73.2487C77.8996 74.9224 76.5428 76.2791 74.8692 76.279L11.7767 76.2752C10.1032 76.2751 8.74658 74.9184 8.74658 73.2449V41.1992C8.74658 40.2442 9.19675 39.3451 9.96136 38.773Z",
    fill: "url(#paint0_radial_26747_24099)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.74658 84.0638V41.7772L43.3232 61.6266L77.8999 41.0967V84.291C77.8999 85.0349 77.6263 85.7528 77.1312 86.3079L74.9921 88.7066C74.4171 89.3514 73.5942 89.7201 72.7303 89.72L14.7829 89.716C14.0506 89.716 13.3432 89.4508 12.7913 88.9694L9.78509 86.3475C9.12526 85.772 8.74658 84.9393 8.74658 84.0638Z",
    fill: "url(#paint1_radial_26747_24099)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_26747_24099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.486 82.7319L43.3233 61.626L75.0487 83.0048C76.5618 84.0244 76.8373 86.1401 75.6358 87.5132L75.0234 88.2131C74.448 88.8708 73.6166 89.248 72.7427 89.2479L15.301 89.2439C14.5589 89.2438 13.8426 88.9715 13.288 88.4785L12.1844 87.4975C10.7119 86.1886 10.8602 83.8447 12.486 82.7319Z",
    fill: "url(#paint2_radial_26747_24099)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.9252 17.9766C13.9252 19.8543 15.5832 21.391 17.6092 21.391C15.5832 21.391 13.9252 22.9276 13.9252 24.8054C13.9252 22.9276 12.2672 21.391 10.2412 21.391C12.2672 21.391 13.9252 19.8543 13.9252 17.9766Z",
    fill: "#18D5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9252 37.9766C63.9252 39.8543 65.5832 41.391 67.6092 41.391C65.5832 41.391 63.9252 42.9276 63.9252 44.8054C63.9252 42.9276 62.2672 41.391 60.2412 41.391C62.2672 41.391 63.9252 39.8543 63.9252 37.9766Z",
    fill: "#18D5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9252 7.97656C59.9252 9.85431 61.5832 11.391 63.6092 11.391C61.5832 11.391 59.9252 12.9276 59.9252 14.8054C59.9252 12.9276 58.2672 11.391 56.2412 11.391C58.2672 11.391 59.9252 9.85431 59.9252 7.97656Z",
    fill: "#18D5B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26747_24099",
    x: 4.70618,
    y: 7.94949,
    width: 77.2336,
    height: 71.3596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.0101
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.0202
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26747_24099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26747_24099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_26747_24099",
    x: 7.12659,
    y: 56.5755,
    width: 73.2996,
    height: 35.7029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.0101
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.0202
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26747_24099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26747_24099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_26747_24099",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3232 69.7273) rotate(-90) scale(55.6468 52.7399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5541CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740385,
    stopColor: "#7A69E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_26747_24099",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.72257 -61.4408 59.348 2.53179 43.051 89.7151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#735FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740385,
    stopColor: "#9887FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_26747_24099",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.323 89.2468) rotate(-87.5104) scale(62.1887 58.94)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#735FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740385,
    stopColor: "#9887FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolNoHistoryList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_no_history_list.c2352e7d0c2a06c71d0e49593f0caf86.svg";